import React from 'react';
import { useTranslation } from 'react-i18next';
import '../../../../assets/stylesheets/Footer.scss'
import { NavLink } from "react-router-dom";
import configs from "../../../../config/config";
const items = configs.mainMenuItems;

const Footer = () => {
    const { t } = useTranslation();
    return (
        <nav className={`footer`}>
            {
                items.map(item => (
                    <NavLink
                        key={item}
                        activeClassName="active"
                        to={`/${item}`}
                        className={`footerItem ${item}`}>
                        <div className={`footerContent`}>
                            <p className={`icon ${item}`}></p>
                            <span>{t(`footer.items.${item}`)}</span>
                        </div>
                    </NavLink>
                ))
            }
        </nav>
    )
}
export default Footer;
